import { useMutation } from '@tanstack/react-query';
import { ApiClient, useApiClient } from 'api/context-provider/useApiClient';
import { ApiError, InferFetchData, throwOnError } from 'api/helpers';

export function useTriggerGenericSpfVerificationMailMutation(id: number | undefined) {
  const apiClient = useApiClient();
  return useMutation<InferFetchData<typeof triggerGenericSpfVerificationMail>, ApiError>({
    mutationKey: ['TriggerGenericSpfVerificationMail'],
    mutationFn: async () => throwOnError(triggerGenericSpfVerificationMail(apiClient, id!)),
  });
}

function triggerGenericSpfVerificationMail(apiClient: ApiClient, id: number) {
  return apiClient.GET('/op/v2/workshop-verification-request/{id}/send-spf-link-email', {
    params: {
      path: {
        // @ts-expect-error BE docs incorrect => should be a number.
        id,
      },
    },
  });
}
useTriggerGenericSpfVerificationMailMutation.getKey = (id: number | undefined) => ['TriggerGenericSpfVerificationMail', id] as const;
